/* eslint-disable camelcase */
import dayjs from 'dayjs'

import {
  IConvertedBetHistory,
  IConvertedSession,
  IServerResponseBetHistory,
  IServerResponseSession,
  ISubbetDTO,
  ISubbetItem,
} from 'shared/models/Softion'

export class SoftionConverter {
  convertBetHistory = (data: IServerResponseBetHistory): IConvertedBetHistory => {
    const bets = data.results.map(item => ({
      id: item.id,
      date: dayjs(item.date).format('DD/MM/YYYY'),
      time: dayjs(item.date).format('HH:mm'),
      amountIn: +(+item.sum_bet_amounts).toFixed(2),
      amountOut: +(+item.sum_win_amounts).toFixed(2),
      coef: +(+item.coef)?.toFixed(2),
      status: item.status,
      provider: item.provider,
      producer: item.producer,
      ticketId: item.id_on_service,
      ticketCode: item.code_on_service,
      ticketType: item.type_on_service,
      userId: item.user.id,
      subBets: item.sub_bets.map(subItem => this.convertSubBet(subItem)),
    }))
    return {
      count: data.count,
      list: bets,
    }
  }

  convertSubBet = (item: ISubbetDTO): ISubbetItem => ({
    id: item.id,
    subticketId: item.id_on_service,
    name: item.name,
    tournament: item.tournament,
    status: item.status,
    otcName: item.outcome_name,
    otcMarket: item.outcome_market,
    odd: item.coef,
    date: dayjs(item.date).format('DD/MM/YYYY HH:mm'),
  })

  convertSessionUrl = (data: IServerResponseSession): IConvertedSession => {
    const { token, sport_link } = data

    return {
      sport_link,
      token,
    }
  }
}
